// extracted by mini-css-extract-plugin
export default {"image":"RecentSaleImage__image-NSHr"};